import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import Apis from '@/Apis/_'
import { User, Convite, EnvioConvite, TipoConviteEnum, CadastroMedicoBackoffice, UsuarioTipo, DataTablePagination } from '@/types/_'
import { CadastroMedico } from '@/types/core'
import { timeout, getUser, handleEspecialidades } from '@/utils/common'

type CadastroMedicoHospital = {
  id: string,
  nome: string,
}

type DadosDoMedicoNosHospitais = {
  readonly medicoId: string,
  readonly hospitalId: string,
  readonly hospitalNome: string,
  readonly medicoHisId?: string,
  status: 'Ativo' | 'Removido',
}

interface MedicoCadastrado {
  medicoId: string,
  nome: string,
  emailPrincipal: string,
  emailsSecundarios: string[],
  cpf: string,
  conselhoTipo: 'CRM' | 'CRO',
  conselhoNumero: string,
  conselhoUf: string,
  descricaoEspecialidadePrincipal: string,
  cboIds: string[],
  dadosDoMedicoNosHospitais: DadosDoMedicoNosHospitais[],
  edicaoRestrita?: boolean,
  podeSerAlterado?: boolean,
}

interface MedicoAssociado {
  id: string,
  nome: string,
  email: string,
  cpf: string,
  conselhoTipo: 'CRM' | 'CRO' | '',
  conselhorNumero: string,
  conselhoUf: string,
  especialidade: string,
}

@Module({ namespaced: true, name: 'BackofficeCadastroMedicoStore' })
export default class BackofficeCadastroMedicoStore extends VuexModule {
  private cadastroMedico: CadastroMedico.ICadastroMedico = new CadastroMedico.CadastroMedico()
  public user: User = { ...getUser() }

  public modalConvite: boolean = false
  public disableOnResend: boolean = false

  public modal: any = {
    alterarMedico: false,
    assinaturaMedico: false,
    cadastroMedicoAssociarCadastro: false,
  }

  private conviteDefault: EnvioConvite = {
    nome: '',
    cpf: '',
    email: '',
    tipo: TipoConviteEnum.MedicoAgendamento,
    hospitais: [],
  }

  private convitesDefault: any[] = []

  public convite: EnvioConvite = { ...this.conviteDefault }
  public convites: Convite[] = [...this.convitesDefault]

  private cadastroMedicoBackofficeDefault: CadastroMedicoBackoffice = {
    nome: '',
    cpf: '',
    emailPrincipal: '',
    emailsSecundarios: [],
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    cbos: [],
  }

  public cadastroMedicoBackoffice: CadastroMedicoBackoffice = { ...this.cadastroMedicoBackofficeDefault }

  public medicosCadastrados: any = []
  public emailsConvite: any[] = []
  public listaConvites: boolean = false
  public listaMedicos: boolean = false
  public conviteSearch: string = ''
  public medicoSearch: string = ''
  public conviteTableHeaders: any[] = [
    { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
    { text: 'E-mail', class: 'table-headers', align: 'center', value: 'email' },
    { text: 'Status', class: 'table-headers', align: 'center', value: 'status.display' },
    { text: 'Ações', class: 'table-headers', align: 'center', sortable: false },
  ]

  public medicoTableHeaders: any[] = [
    { text: 'Nome do médico', class: 'table-headers', align: 'left', value: 'medicoLogin', sortable: false },
    { text: 'CPF do médico', class: 'table-headers', align: 'left', value: 'medicoCpf', sortable: false },
    { text: 'Login do médico', class: 'table-headers', align: 'center', value: 'medicoLogin', sortable: false },
    { text: 'Nome da secretária', class: 'table-headers', align: 'left', value: 'secretariaNome', sortable: false },
    { text: 'Login da secretária', class: 'table-headers', align: 'center', value: 'secretariaLogin', sortable: false },
    { text: 'E-mails', class: 'table-headers', align: 'center', value: 'emails', sortable: false },
  ]

  public conviteTableLoading: boolean = false
  private usuarioTipoDefault: UsuarioTipo = {
    id: '',
    nome: '',
    tipo: '',
  }

  public usuarioTipo: UsuarioTipo = { ...this.usuarioTipoDefault }
  public assinatura: string = ''
  public cbos: any[] = []
  public hospitais: CadastroMedicoHospital[] = []

  @Mutation
  addEmailsSecundarios(value: string) {
    this.cadastroMedicoBackoffice.emailsSecundarios.push(value)
  }

  @Mutation
  removeEmailsSecundarios(index: number) {
    this.cadastroMedicoBackoffice.emailsSecundarios.splice(index, 1)
  }

  @Mutation
  clearEmailsSecundarios() {
    this.cadastroMedicoBackoffice.emailsSecundarios = []
  }

  @Mutation
  clearCadastroMedicoBackoffice() {
    this.cadastroMedicoBackoffice = { ...this.cadastroMedicoBackofficeDefault }
  }

  @Mutation
  setDisableOnResend(value: boolean) {
    this.disableOnResend = value
  }

  @Mutation
  setHospitais(value: CadastroMedicoHospital[]) {
    this.hospitais = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  setCbos(value: any[]) {
    this.cbos = value
  }

  @Mutation
  removeCboFromList(id: string) {
    if (this.medicoCadastrado.cboIds.includes(id)) {
      this.medicoCadastrado.cboIds.splice(this.medicoCadastrado.cboIds.indexOf(id), 1)
    }
  }

  @Mutation
  setAssinatura(value: string) {
    this.assinatura = value
  }

  @Mutation
  setModal(modal: any) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setEmailsConvite(value: any) {
    this.emailsConvite = value
  }

  @Mutation
  setEmailConvite(value: any) {
    this.emailsConvite.push(value)
  }

  @Mutation
  removeEmailConvite(index) {
    this.emailsConvite.splice(index, 1)
  }

  @Mutation
  setConviteTableLoading(value: boolean) {
    this.conviteTableLoading = value
  }

  @Mutation
  setConvite(value: EnvioConvite) {
    this.convite = value
  }

  @Mutation
  clearConvite() {
    this.convite = { ...this.conviteDefault }
  }

  @Mutation
  setConvites(value: Convite[]) {
    this.convites = value
  }

  @Mutation
  clearConvites() {
    this.convites = [...this.convitesDefault]
  }


  @Mutation
  setConviteSearch(value: string) {
    this.conviteSearch = value
  }

  @Mutation
  clearConviteSearch() {
    this.conviteSearch = ''
  }

  @Mutation
  setMedicoSearch(value: string) {
    this.medicoSearch = value
  }

  @Mutation
  clearMedicoSearch() {
    this.medicoSearch = ''
  }

  @Mutation
  setMedicoAssistentes(medicos: any[]) {
    this.medicosCadastrados = medicos
  }

  @Mutation
  setListaConvites(value: boolean) {
    this.listaConvites = value
  }

  @Mutation
  setListaMedicos(value: boolean) {
    this.listaMedicos = value
  }

  @Mutation
  setUser(value: User) {
    this.user = value
  }

  @Mutation
  setUsuarioTipo(params: any) {
    this.usuarioTipo.id = params.id
    this.usuarioTipo.nome = params.nome
    this.usuarioTipo.tipo = params.tipo
  }

  @Action({ commit: 'setHospitais' })
  async getHospitalCurrentUser() {
    try {
      const request = await this.cadastroMedico.getHospitalCurrentUser()
      return request.success ? request.data as CadastroMedicoHospital[] : []
    } catch (error) {
      return []
    }
  }

  @Action({ commit: 'setConvites' })
  async getConvites() {
    const hospitais = _.map(this.hospitais, 'id')
    const request = await this.cadastroMedico.getConvitesAll(hospitais)
    if (request.success) this.context.commit('setListaConvites', true)
    return request.data
  }

  // @Action({ commit: 'setConvites' })
  // async getConvites() {
  //   const hospitalResponse = await this.cadastroMedico.getHospitalCurrentUser()
  //   const hospitais = _.map(hospitalResponse.data, 'id')
  //   const request = await this.cadastroMedico.getConvitesAll(hospitais)
  //   if (request.success) this.context.commit('setListaConvites', true)
  //   return request.data
  // }

  @Action({ commit: 'setMedicoAssistentes' })
  async loadMedicoAssistentesAll() {
    try {
      const request = await this.cadastroMedico.medicoAssistentesAll()
      return request.success ? request.data : []
    } catch (error) {
      return []
    }
  }

  @Action
  async sendConvite() {
    let request: any
    const hospitalResponse = await this.cadastroMedico.getHospitalCurrentUser()
    const { convite } = this
    const param: any = {
      nome: convite.nome.replace(/\s{2,}/g, ' '),
      hospitais: _.map(hospitalResponse.data, 'id'),
      cpf: convite.cpf,
      email: convite.email,
      tipo: convite.tipo,
      emails: this.emailsConvite.map(c => c.email),
    }

    try {
      request = await this.cadastroMedico.sendConvite(param)
      this.setConviteTableLoading(true)
      await timeout(700)
      await this.context.dispatch('getConvites')
      this.setConviteTableLoading(false)
    } catch (e) {
      return e
    }

    return request
  }

  @Action
  async resendConvite(conviteId: string) {
    let request: any

    try {
      request = await this.cadastroMedico.resendConvite(conviteId)
      this.setConviteTableLoading(true)
      await timeout(700)
      await this.context.dispatch('getConvites')
      this.setConviteTableLoading(false)
    } catch (e) {
      return e
    }

    return request
  }

  @Action
  async deletarConvite(conviteId: string) {
    const request = await this.cadastroMedico.deletarConvite(conviteId)
    return request
  }

  @Action
  async sendCadastroMedico() {
    try {
      const request = await this.cadastroMedico.cadastrarMedicoBackoffice(this.cadastroMedicoBackoffice)
      if (request.success && request.data.ehMedicoCadastrado) this.context.commit('setMedicoASerAssociado', request.data.medico as MedicoAssociado)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getUsuarioTipoExistsByCpf(cpf: string) {
    const params: any = {
      cpf,
    }

    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getUsuarioTipoExistsByCpf(params)
    if (request.success) {
      this.context.commit('setUsuarioTipo', request.data)
    }
    return request
  }

  @Action
  async associarMedicoHospital() {
    const params: any = {
      medicoId: this.usuarioTipo.id,
    }

    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.associarMedicoHospital(params)
    return request
  }

  @Action
  async getBackofficeAssinaturaDoMedico(medicoId: string) {
    try {
      const request = await this.cadastroMedico.getBackofficeAssinaturaDoMedico(medicoId)
      this.context.commit('setAssinatura', request.success ? request.data as string : '')
      return request
    } catch (error) {
      this.context.commit('setAssinatura', '')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Médicos Cadastrados */
  public medicoReadonly: boolean = false
  public podeSerAlterado: boolean = false

  private paginationMedicosCadastradosDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25, 50, 100],
  }

  public paginationMedicosCadastrados: DataTablePagination = { ...this.paginationMedicosCadastradosDefault }
  public medicos: MedicoCadastrado[] = []
  public medicosSearch: string = ''
  public ehAlteracaoDeStatus: boolean = false

  private medicoCadastradoDefault: MedicoCadastrado = {
    medicoId: '',
    nome: '',
    emailPrincipal: '',
    emailsSecundarios: [],
    cpf: '',
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    descricaoEspecialidadePrincipal: '',
    cboIds: [],
    dadosDoMedicoNosHospitais: [],
  }

  public medicoCadastrado: MedicoCadastrado = { ...this.medicoCadastradoDefault }

  @Mutation
  setEhAlteracaoDeStatus(value: boolean) {
    this.ehAlteracaoDeStatus = value
  }

  @Mutation
  setMedicoReadonly(value: boolean) {
    this.medicoReadonly = value
  }

  @Mutation
  setPodeSerAlterado(value: boolean) {
    this.podeSerAlterado = value
  }

  @Mutation
  setMedicosSearch(value: string) {
    this.medicosSearch = value
  }

  @Mutation
  clearMedicosSearch() {
    this.medicosSearch = ''
  }

  @Mutation
  setPaginationMedicoCadastrado(value: DataTablePagination) {
    this.paginationMedicosCadastrados = value
  }

  @Mutation
  resetPaginationMedicoCadastrado() {
    this.paginationMedicosCadastrados = { ...this.paginationMedicosCadastradosDefault }
  }

  @Mutation
  setMedicos(value: MedicoCadastrado[]) {
    this.medicos = value
  }

  @Mutation
  clearMedicos() {
    this.medicos = []
  }

  @Mutation
  setMedicoCadastrado(val: MedicoCadastrado) {
    if (!val) this.medicoCadastrado = { ...this.medicoCadastradoDefault }

    Object.entries(val).forEach(([key, value]) => {
      if (key === 'dadosDoMedicoNosHospitais' && !!key.length) {
        value.map((dadosDoMedico: DadosDoMedicoNosHospitais) => {
          const dados = { ...dadosDoMedico }
          if (!dados.medicoHisId) dados.medicoHisId = ''
          return dados
        })
      }
    })

    this.medicoCadastrado = { ...this.medicoCadastradoDefault, ...val }
  }

  @Mutation
  clearMedicoCadastrado() {
    this.medicoCadastrado = { ...this.medicoCadastradoDefault }
  }

  @Mutation
  addEmailSecundario(value: string) {
    this.medicoCadastrado.emailsSecundarios.push(value)
  }

  @Action
  async getAllCadastrosMedicosByUsuarioHospital(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginationMedicosCadastradosDefault.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationMedicosCadastradosDefault.rowsPerPage,
        searchText: this.medicosSearch,
      }

      const request = await this.cadastroMedico.getAllCadastrosMedicosByUsuarioHospital(params)

      if (request.success) {
        this.context.commit('setMedicos', request.data.cadastrosMedicos as MedicoCadastrado[])
        this.context.commit('setPodeSerAlterado', request.data.podeSerAlterado as boolean)
        this.context.commit('setPaginationMedicoCadastrado', {
          descending: false,
          page: pagination.page || this.paginationMedicosCadastradosDefault.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationMedicosCadastradosDefault.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationMedicosCadastradosDefault.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  private medicoASerAssociadoDefault: MedicoAssociado = {
    id: '',
    nome: '',
    email: '',
    cpf: '',
    conselhoTipo: '',
    conselhorNumero: '',
    conselhoUf: '',
    especialidade: '',
  }

  public medicoASerAssociado: MedicoAssociado = { ...this.medicoASerAssociadoDefault }

  @Mutation
  setMedicoASerAssociado(value: MedicoAssociado) {
    this.medicoASerAssociado = value
  }

  @Mutation
  clearMedicoASerAssociado() {
    this.medicoASerAssociado = { ...this.medicoASerAssociadoDefault }
  }

  @Action
  async backofficeAssociaPreCadastroExistente() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAssociaPreCadastroExistente({ ...this.medicoASerAssociado })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getMedicoDadosPreCadastro(medicoId: string) {
    try {
      const request = await this.cadastroMedico.getMedicoDadosPreCadastro(medicoId)
      if (request.success) this.context.commit('setMedicoCadastrado', request.data.cadastroMedico as MedicoCadastrado)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async backofficeAlterarMedico(edicaoRestrita: boolean = false) {
    try {
      const params: any = handleEspecialidades({ ...this.medicoCadastrado }, this.cbos)

      Object.entries(params).forEach(([key, value]) => {
        // Limpar todos os parâmetros vazios..
        if (['', null, undefined].includes(value as any)) {
          delete params[key]
        }

        // Limpar e-mails secundários...
        if (key === 'emailsSecundarios') {
          params[key] = params[key].filter(item => item)
        }

        // Limpar HisIds vazios...
        if (key === 'dadosDoMedicoNosHospitais') {
          params[key] = params[key].map((dadosDoMedico: DadosDoMedicoNosHospitais) => {
            const dados = { ...dadosDoMedico }
            if (!dados.medicoHisId) delete dados.medicoHisId
            return dados
          })
        }
      })

      const request = await this.cadastroMedico.backofficeAlterarMedico({ ...params, edicaoRestrita })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async backofficeAtualizaTipoMedicoEOrdenacao(params: any) {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAtualizaTipoMedicoEOrdenacao(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
